import { ServiceName } from '../enums/service-name.enum';
import { ApiEndpoint } from '../models/api-endpoint.model';

export const API_ENDPOINTS: ApiEndpoint[] = [
  {
    name: 'SSO Service',
    serviceName: ServiceName.SSO,
    description: 'Manages single sign-on and user authentication.',
  },
  {
    name: 'File Uploader Service',
    serviceName: ServiceName.File,
    description: 'Handles file upload and storage operations.',
  },
  {
    name: 'Audit Trail Service',
    serviceName: ServiceName.Audit,
    description: 'Tracks and records all system-level events for auditing.',
  },
  {
    name: 'Company Service',
    serviceName: ServiceName.Company,
    description: 'Manages company-related data and operations.',
  },
  {
    name: 'Deal Service',
    serviceName: ServiceName.Deal,
    description: 'Handles deal creation, tracking, and management.',
  },
  {
    name: 'Document Service',
    serviceName: ServiceName.Document,
    description: 'Provides document management and storage capabilities.',
  },
  // TODO: Uncomment when service will be ready with actual data
  // {
  //   name: 'Integration Service',
  //   serviceName: ServiceName.Integration,
  //   description: 'Facilitates integration with external APIs and services.',
  // },
  {
    name: 'Notification Service',
    serviceName: ServiceName.Notification,
    description: 'Manages sending notifications to users and systems.',
  },
  {
    name: 'Workflow Service',
    serviceName: ServiceName.Workflow,
    description: 'Orchestrates and automates business workflows.',
  },
];
